export default function createPatientFullName(obj) {
  const { first_name, midle_name, last_name, firstname, lastname, fathername } = obj;

  if (first_name) {
    if (midle_name.length > 0) {
      return `${first_name || ''} ${midle_name || ''} ${last_name || ''}`;
    }
    return `${first_name || ''} ${last_name || ''}`;
  }
  if (firstname) {
    if (fathername) {
      return `${lastname || ''} ${firstname || ''} ${fathername || ''}`;
    }
    return `${lastname || ''} ${firstname || ''}`;
  }
  if (lastname) {
    if (fathername) {
      return `${lastname || ''} ${firstname || ''} ${fathername || ''}`;
    }
    return `${lastname || ''} ${firstname || ''}`;
  }
}
